import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import Cropper from 'react-easy-crop';
import './ImageCropper.scss';

const MIN_ZOOM = 0.5;
const MAX_ZOOM = 3;

const ImageCropper = props => {
  const { imageSrc, aspectRatio, onCropComplete, onMediaLoaded, onAdjust, frameLabel } = props;
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);

  const handleMediaLoaded = useCallback(mediaSize => onMediaLoaded?.(mediaSize), [onMediaLoaded]);

  const handleCropComplete = useCallback(
    (croppedArea, croppedAreaPixels) => {
      onCropComplete?.(croppedAreaPixels);
    },
    [onCropComplete]
  );

  const handleCropChange = useCallback(
    next => {
      if (next.x !== 0 || next.y !== 0) onAdjust?.();
      setCrop(next);
    },
    [onAdjust]
  );

  const handleZoomChange = useCallback(
    next => {
      if (next !== 1) onAdjust?.();
      setZoom(next);
    },
    [onAdjust]
  );

  return (
    <div className='image-cropper'>
      <div className='image-cropper-container'>
        <Cropper
          image={imageSrc}
          crop={crop}
          zoom={zoom}
          aspect={aspectRatio}
          objectFit='contain'
          minZoom={MIN_ZOOM}
          restrictPosition={false}
          onCropChange={handleCropChange}
          onZoomChange={handleZoomChange}
          onCropComplete={handleCropComplete}
          onMediaLoaded={handleMediaLoaded}
          style={{
            cropAreaStyle: {
              border: '2px solid #fff',
              boxShadow: '0 0 0 9999px rgba(0, 0, 0, 0.55)',
              color: 'transparent'
            }
          }}
        />
        {frameLabel && <div className='image-cropper-frame-label'>{frameLabel}</div>}
      </div>
      <div className='image-cropper-controls'>
        <label className='image-cropper-zoom-label'>Zoom</label>
        <input
          type='range'
          className='image-cropper-zoom-slider'
          min={MIN_ZOOM}
          max={MAX_ZOOM}
          step={0.02}
          value={zoom}
          style={{ '--progress': `calc(7px + ${(zoom - MIN_ZOOM) / (MAX_ZOOM - MIN_ZOOM)} * (100% - 14px))` }}
          onChange={e => handleZoomChange(Number(e.target.value))}
        />
      </div>
    </div>
  );
};

ImageCropper.propTypes = {
  imageSrc: PropTypes.string.isRequired,
  aspectRatio: PropTypes.number,
  onCropComplete: PropTypes.func,
  onMediaLoaded: PropTypes.func,
  onAdjust: PropTypes.func,
  frameLabel: PropTypes.string
};

export default ImageCropper;
